'use strict';

exports.__esModule = true;
exports.hasSendBeacon = hasSendBeacon;
exports.sendBeacon = sendBeacon;
var envFallback = {};

var env = exports.env = function env() {
  if (typeof window !== 'undefined') {
    return window;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof WorkerGlobalScope !== 'undefined') {
    /* global WorkerGlobalScope */
    return WorkerGlobalScope;
  } else {
    return envFallback;
  }
};

function hasSendBeacon() {
  return typeof navigator !== 'undefined' && navigator && navigator.sendBeacon;
}

function sendBeacon(url) {
  return navigator.sendBeacon(url);
}